import { z } from 'zod';
/**
 * Document integrations work on two distinct levels — keep them separate:
 *
 * 1. `DocumentResourceType` is the ENTITY a document lives in (which table to load
 *    and how). It's the routing key for the publish endpoint's `documentResolvers`
 *    and for each integration worker. Add a value here only when integrating a
 *    brand-new kind of record (e.g. a future `LEGISLATIVE_ITEM_DOCUMENT`).
 *
 * 2. `documentType` (e.g. `MeetingEventDocumentType`: agenda_outline, minutes, …) is
 *    the SUBTYPE within a resource. A government enables/disables specific subtypes
 *    per integration via `enabledDocumentTypes`. New kinds of meeting documents are
 *    new `documentType`s — NOT new resource types.
 *
 * So `enabledDocumentTypes` is intentionally a subset of subtypes *within* a single
 * `DocumentResourceType`, not a peer of it.
 */
export var DocumentResourceType;
(function (DocumentResourceType) {
    DocumentResourceType["MEETING_EVENT_DOCUMENT"] = "meeting_event_document";
})(DocumentResourceType || (DocumentResourceType = {}));
export var DocumentIntegration;
(function (DocumentIntegration) {
    DocumentIntegration["LASERFICHE"] = "laserfiche";
})(DocumentIntegration || (DocumentIntegration = {}));
export var DocumentIntegrationSyncStatus;
(function (DocumentIntegrationSyncStatus) {
    DocumentIntegrationSyncStatus["PENDING"] = "pending";
    DocumentIntegrationSyncStatus["SYNCED"] = "synced";
    DocumentIntegrationSyncStatus["FAILED"] = "failed";
})(DocumentIntegrationSyncStatus || (DocumentIntegrationSyncStatus = {}));
export const publishDocumentRequestSchema = z.object({
    resourceType: z.enum(DocumentResourceType, 'Unsupported resource type'),
    resourceId: z
        .number('Resource ID is required')
        .int('Resource ID must be a whole number')
        .positive('Resource ID must be a positive number'),
});
